import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import { getQueryParam } from '../routing/getQueryParam';
import { getPreferredLocale } from '../i18n/LocaleUtils';
export const requestPurchaseProductInfo = () => {
  const dtbId = getQueryParam('dtbId');
  const locale = getPreferredLocale();
  return noAuthApiClient.post(`/acquisition/v1/product-info`, {
    data: {
      dtbId,
      locale
    }
  });
};